export default "__VITE_ASSET__CmPT5UEL__"